export const VERIFIED = "VERIFIED";
export const USER = "USER";
export const AUTH_TOKEN = "AUTH_TOKEN";
export const AUTHENTICATED = "AUTHENTICATED";
